import { applyTheme, getInitialTheme } from "./theme";

applyTheme(getInitialTheme());
